<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Appraisal</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Occupier</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create Occupier</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Originating M.D.A.</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="mda" required>
                        <option value="" disabled>- Select MDA -</option>
                        <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Approval Authority</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="approval_authority" required>
                        <option value="" disabled>- Select Approving Authority -</option>
                        <option v-for="app in approval_authorities" :key="app.id" :value="app.id">{{ app.description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Name</label></div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" v-model="approval_authority_name" placeholder="" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Email</label></div>
                    <div class="col-md-9 input-right">
                      <div class="col-md-12 input-right">
                        <input type="email" class="form-control" v-model="email" placeholder="" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">OG Number</label></div>
                    <div class="col-md-9 input-right">
                      <div class="col-md-12 input-right">
                        <input type="text" class="form-control" v-model="og_number" placeholder="">
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="subsector" class="form-label">User ID</label></div>
                                    <div class="col-md-9 input-right">
                                      <input type="number" class="form-control" v-model="user_id" placeholder="" required>
                                    </div>
                                </div> -->

                  <div class="d-flex justify-content-center ">
                    <button class="submit-btn" type="submit" :disabled="isLoading">
                      <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ isLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie';

const root_api_url = process.env.VUE_APP_API_ROOT_URL

// Reactive form data
// const form = reactive({
//   mdaName: '',
//   organizationCode: '',
//   economicLineItemId: '',
//   year:''
// })

const isLoading = ref(false);
const mda = ref('');
const approval_authority = ref('');
const approval_authority_name = ref('');
const email = ref('');
const user_id = ref('');
const og_number = ref('');



const approval_authorities = ref([])
const mdas = ref([])

const fetchMDAs = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}


const fetchApprovalAuthority = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/app-auth`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    approval_authorities.value = response.data.map(approval_authority => ({
      id: approval_authority.id,
      description: approval_authority.description
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}


const handleSubmit = async () => {
  const token = Cookies.get('auth_token');
  isLoading.value = true;

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  // console.log(approval_authority.value);
  const OccupierData = {
    mdaId: mda.value,
    approvalAuthorityId: approval_authority.value,
    name: approval_authority_name.value,
    email: email.value,
    ogNumber: og_number.value ?? 'N/A',
  };

  try {
    const result = await axios.post(`${root_api_url}/eli/occupier`, OccupierData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log("inside:", OccupierData)
    if (result.status === 201) {
      Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Occupier Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      mda.value = ''
      approval_authority.value = ''
      approval_authority_name.value = ''
      email.value = ''
      user_id.value = ''
    }
  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create occupier</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred, kindly contact administrator.'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator.</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchApprovalAuthority(),
  fetchMDAs(),
  document.title = "Create Occupier"
})

</script>
